import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var ChessQueen = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 512 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M312 56c0-30.9-25.1-56-56-56s-56 25.1-56 56 25.1 56 56 56 56-25.1 56-56zM64 480c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32s-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zM34 169.4 9.2 185.8C3.5 189.7 0 196.2 0 203.1c0 3.2.7 6.4 2.2 9.3L104 416h304l101.8-203.6c1.4-2.9 2.2-6.1 2.2-9.3 0-6.9-3.5-13.4-9.2-17.3L478 169.4c-8.2-5.4-19-4.4-26 2.6-12.9 12.9-30.9 21.9-48 15.5-17.9-6.7-28.1-20.1-32.8-35.8C367.5 139 357.3 128 344 128h-16c-13.3 0-23.9 11.2-29.6 23.2-5.8 12.2-17.8 24.8-42.4 24.8s-36.6-12.6-42.4-24.8c-5.7-12-16.3-23.2-29.6-23.2h-16c-13.3 0-23.5 11-27.3 23.7-4.7 15.6-14.9 29.1-32.8 35.8-17 6.4-35.1-2.7-48-15.5-6.9-6.9-17.8-8-25.9-2.6z"
  }));
});
ChessQueen.displayName = 'ChessQueen';
export var ChessQueenDimensions = {
  height: 512,
  width: 512
};